import InputCalendar from '@components/InputCalendar';
import type { Comparator } from '@domain/schemas/filters.schema';

import { RelativeDateSelect } from './RelativeDateSelect';

interface DateInputProps {
  comparator: Comparator;
  values: string[];
  onChange: (values: string[]) => void;
}

export function DateInput({ comparator, values, onChange }: DateInputProps) {
  if (comparator === 'rel') {
    return <RelativeDateSelect value={values} onChange={(v) => onChange(v ?? [])} />;
  }
  return (
    <InputCalendar
      shouldRenderInsidePortal={true}
      name="query-builder-date"
      value={values[0] ?? null}
      emptyValue={null}
      onChange={(v) => onChange(v ? [String(v)] : [])}
      wrapperClassName="w-full"
      className="bg-white"
    />
  );
}
